import { render, staticRenderFns } from "./inventoryQueryNew.vue?vue&type=template&id=505ad37c&scoped=true&"
import script from "./inventoryQueryNew.vue?vue&type=script&lang=js&"
export * from "./inventoryQueryNew.vue?vue&type=script&lang=js&"
import style0 from "./inventoryQueryNew.vue?vue&type=style&index=0&id=505ad37c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505ad37c",
  null
  
)

export default component.exports